/**
 * Generate a deterministic, visually distinct hex color from a string.
 * Uses a hash of the characters to produce a hue, with fixed saturation
 * and lightness to ensure colors are vibrant and readable on maps.
 */
export function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Use the hash to pick a hue (0-360), keep saturation and lightness fixed
  const hue = ((hash % 360) + 360) % 360;
  const saturation = 70; // Vibrant but not neon
  const lightness = 45; // Dark enough to see on light maps

  return hslToHex(hue, saturation, lightness);
}

function hslToHex(h: number, s: number, l: number): string {
  s /= 100;
  l /= 100;

  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0");
  };

  return `#${f(0)}${f(8)}${f(4)}`;
}
